import axios from 'axios'
console.log('请求查看环境', process.env.VUE_APP_BASE_URL);
const baseURL = process.env.VUE_APP_BASE_URL
export const http = new axios.create({
  baseURL: baseURL,
  timeout: 30000
})

